<div class="card p-input-filled full-height">
  <p-table
    #dt
    dataKey="id"
    [value]="gridItems"
    [lazy]="true"
    selectionMode="single"
    [(selection)]="selectedItem"
    [resizableColumns]="true" columnResizeMode="expand"
    (onLazyLoad)="fetchDataViaTableComponent($event)"
    [paginator]="true"
    [first]="gridMeta.lazyLoadMeta?.first ?? 0"
    [rows]="gridMeta.lazyLoadMeta?.rows ?? 20"
    [rowsPerPageOptions]="[10, 20, 50]"
    showCurrentPageReport="true"
    currentPageReportTemplate="{first} - {last} / {totalRecords}"
    [paginatorDropdownAppendTo]="'body'"
    [totalRecords]="totalRecords"
    [sortMode]="'multiple'"
    [multiSortMeta]="gridMeta.lazyLoadMeta?.multiSortMeta"
    [filters]="gridMeta.filters!"
    [scrollable]="true" scrollHeight="var(--explorer-grid-height)"
    [tableStyle]="{ 'min-width': '50rem' }"
    styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th id="defaultpicture" style="width:1px" pResizableColumn>
        </th>
        <th *showIfDebugMode id="id" style="min-width:8rem" pSortableColumn="id" pResizableColumn>
          Id
          <p-sortIcon field="id"></p-sortIcon>
          <p-columnFilter type="numeric" field="id" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="locationPretty" style="min-width:10rem" pSortableColumn="locationPretty" pResizableColumn>
          {{ 'LOCATION.LOCATION' | translate }}
          <p-sortIcon field="locationPretty"></p-sortIcon>
          <p-columnFilter type="text" field="locationPretty" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="rfid" style="min-width:10rem" pSortableColumn="rfid" pResizableColumn>
          {{ 'RFID' | translate }}
          <p-sortIcon field="rfid"></p-sortIcon>
          <p-columnFilter type="text" field="rfid" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="email" style="min-width:10rem" pSortableColumn="email" pResizableColumn>
          {{ 'EMAIL.EMAIL' | translate }}
          <p-sortIcon field="email"></p-sortIcon>
          <p-columnFilter type="text" field="email" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="employeePretty" style="min-width:10rem" pSortableColumn="employeePretty" pResizableColumn>
          {{ 'EMPLOYEE.EMPLOYEE' | translate }}
          <p-sortIcon field="employeePretty"></p-sortIcon>
          <p-columnFilter type="text" field="employeePretty" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

        <th id="mobile" style="min-width:10rem" pSortableColumn="mobile" pResizableColumn>
          {{ 'MOBILE' | translate }}
          <p-sortIcon field="mobile"></p-sortIcon>
          <p-columnFilter type="boolean" field="mobile" display="menu" [showOperator]="false"></p-columnFilter>
        </th>

      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-toolLocation>
      <tr [pSelectableRow]="toolLocation" (dblclick)="onRowDblClick($event, toolLocation.treeNode)">
        <td style="padding: 0px;"><img id="{{ toolLocationDocumentService.getImgElementId(toolLocation.id) }}" class="img-defaultphoto-icon" src=""></td>
        <td *showIfDebugMode>{{ toolLocation.id }}</td>
        <td>{{ toolLocation.locationPretty }}</td>
        <td>{{ toolLocation.rfid }}</td>
        <td>{{ toolLocation.email }}</td>
        <td>{{ toolLocation.employeePretty }}</td>
        <td>{{ toolLocation.mobile ? 'Y' : 'N' }}</td>
      </tr>
    </ng-template>
    <ng-template id="buttonCreate" pTemplate="paginatorleft">

      <div class="pt-4">
        <button mat-flat-button color="primary" (click)="createNew()" *hasPermission="Permission.LOCATION_CREATE">
          <mat-icon>add</mat-icon>
          {{ 'CREATE' | translate }}
        </button>
        <button mat-flat-button [disabled]="!selectedItem" (click)="delete()" class="mx-1"
                *hasPermission="Permission.LOCATION_DELETE">
          <mat-icon>clear</mat-icon>
          {{ 'DELETE.DELETE' | translate }}
        </button>

        <button mat-flat-button (click)="exportToExcel()" class="mx-1 mt-0">
          <mat-icon>file_download</mat-icon>
          {{ 'EXPORT' | translate }}
        </button>

        <wim-search-input [searchQuery]="gridMeta.searchQuery" (onSearch)="onSearch($event)"></wim-search-input>
      </div>

    </ng-template>
  </p-table>
</div>
